<template>
	<v-card flat class="ma-0">
		<v-form ref="form" @submit.prevent>
			<h6 class="text-body-1 font-weight-bold mt-2">絞り込み</h6>
			<v-row no-gutters justify="center">
				<v-col cols="12" sm="6" lg="4" class="mt-4 px-1">
					<v-text-field
						label="製造番号"
						v-model="q.ordered_product_product_number_cont"
						dense
						outlined
					/>
				</v-col>
				<v-col cols="12" sm="6" lg="4" class="mt-4 px-1">
					<v-text-field label="品名" v-model="q.ordered_product_product_name_cont" dense outlined />
				</v-col>
				<v-col cols="12" sm="6" lg="4" class="mt-4 px-1">
					<v-checkbox
						dense
						v-model="isCheckedShipped"
						@change="changeStatus"
						label="出荷済みも表示"
					/>
				</v-col>
				<v-col cols="12" sm="6" lg="4" class="mt-4 px-1">
					<v-row no-gutters>
						<v-col cols="6" class="pr-1">
							<v-btn width="100%" @click="search" color="secondary">
								<v-icon class="mr-2">mdi-magnify</v-icon>
								検索</v-btn
							>
						</v-col>
						<v-col cols="6" class="pl-1">
							<v-btn width="100%" @click="resetForm" outlined color="secondary">
								<v-icon class="mr-2">mdi-autorenew</v-icon>
								クリア</v-btn
							>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
		</v-form>
	</v-card>
</template>

<script>
export default {
	props: {
		text: {
			type: Boolean,
			default: false,
		},
		query: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			dialog: false,
			q: {
				ordered_product_product_number_cont: null,
				ordered_product_product_name_cont: null,
				status_in: ["order_received", "manufacture_started", "manufacture_completed"],
			},
			isCheckedShipped: false,
		}
	},
	mounted() {
		this.q = this.query
		this.$nextTick(() => {
			if (this.q.status_in.includes("shipped") && this.q.status_in.includes("delivered")) {
				this.isCheckedShipped = true
			}
			if (this.q.attached_files_user_id_eq) {
				this.isCheckedSelf = true
			}
		})
	},
	methods: {
		search() {
			this.$emit("search-attached-files", this.q, this.targetType)
			this.dialog = false
		},
		resetForm() {
			this.$refs.form.reset()
		},
		changeStatus() {
			if (this.isCheckedShipped) {
				this.q.status_in.push("shipped")
				this.q.status_in.push("delivered")
			} else {
				this.q.status_in.splice(-2)
			}
		},
	},
	watch: {
		query: {
			handler(val) {
				this.q = val
			},
			deep: true,
		},
	},
}
</script>
